/// <reference path="../../../app.definition.ts" />

import angular from 'angular';
export class FieldMetadataPopupController {
  static $inject = ["$rootScope", "$timeout", "$uibModalInstance", "PopUpService", "ApiAdapterService", "formField", "newGoal", "goalReqObj"];
  customChoices: any;
  constructor($rootScope, $timeout, $uibModalInstance, PopUpService, ApiAdapterService, formField, newGoal, goalReqObj) {
    var fieldMetadataPopupVm: any = this;
    fieldMetadataPopupVm.formField = formField;
    fieldMetadataPopupVm.formField.newGoal = newGoal;
    fieldMetadataPopupVm.goalReqObj = goalReqObj;
    fieldMetadataPopupVm.cancelTooltip = "If you cancel this " + fieldMetadataPopupVm.formField.title + " will not be saved. Click CANCEL again to confirm.";
    fieldMetadataPopupVm.cancelTooltipEnable = false;
    fieldMetadataPopupVm.cancelCount = 0;
    fieldMetadataPopupVm.metaContents = [];
    fieldMetadataPopupVm.category = {}
    $timeout(() => {
      //var metadataContainer =$('.field-metadata-modal > :not(".meta-cancel")');
      var metadataContainer = $('.field-metadata-modal');
      metadataContainer.click((e) => {
        if (!e.target.classList.contains("meta-cancel")) {
          if (fieldMetadataPopupVm.cancelCount == 1 && !!fieldMetadataPopupVm.cancelTooltipEnable) {
            fieldMetadataPopupVm.cancelCount = 0;
            fieldMetadataPopupVm.cancelTooltipEnable = false;
          }
        }
      })
    }, 100);
    fieldMetadataPopupVm.retrieveSpecificMetadataInfo = () => {
      for (let metaItem of fieldMetadataPopupVm.formField.metadata) {
        if (metaItem.key == "Category") {
          fieldMetadataPopupVm.category.key = metaItem.key;
        }
      }
    }

    fieldMetadataPopupVm.retrieveSpecificMetadataInfo();


    fieldMetadataPopupVm.saveMetadata = () => {
      var catId = null;
      var categoryId = fieldMetadataPopupVm.category.id;
      $rootScope.mainShowLoader = true;
      var existingCat = [];
      if (!!categoryId && categoryId > 0) {
        existingCat = JSON.parse(fieldMetadataPopupVm.category.metaDetail.listOptions).filter(function (cat) {
          return cat.id == categoryId;
        });
        fieldMetadataPopupVm.category.searchData = existingCat[0].name;
        catId = categoryId;
      }
      let reqObj = fieldMetadataPopupVm.goalReqObj;
      let metadata = [{
        optionId: fieldMetadataPopupVm.category.metaDetail.id,
        id: catId,
        value: fieldMetadataPopupVm.category.searchData,
        entityName: fieldMetadataPopupVm.formField.dynamicData,
        entityType: "FORMDYNAMICATTRIBUTE"
      }];
      ApiAdapterService.saveFormDynamicAttribute(reqObj, metadata).then((s) => {
        fieldMetadataPopupVm.category.id = s.metadata[0].id;
        fieldMetadataPopupVm.category.name = s.metadata[0].value;
        fieldMetadataPopupVm.category.goalId = s.id;
        fieldMetadataPopupVm.category.goalName = s.value;
        fieldMetadataPopupVm.category.parentId = s.parentId;
        $rootScope.mainShowLoader = false;
        $uibModalInstance.close(fieldMetadataPopupVm.category);
      }, (e) => {
        fieldMetadataPopupVm.formField['dynamicDataLoading'] = false;
        $rootScope.mainShowLoader = false;
        this.customChoices.pop.openInformationModal(e);
      });

    }

    fieldMetadataPopupVm.dismiss = () => {
      if (fieldMetadataPopupVm.cancelCount == 0) {
        fieldMetadataPopupVm.cancelCount = 1;
        fieldMetadataPopupVm.cancelTooltipEnable = true;
        setTimeout(function () {
          fieldMetadataPopupVm.cancelCount = 0;
          fieldMetadataPopupVm.cancelTooltipEnable = false;
        }, 10000);
      } else if (fieldMetadataPopupVm.cancelCount == 1) {
        if (!!fieldMetadataPopupVm.cancelTooltipEnable) {
          fieldMetadataPopupVm.cancelCount = 0;
          $uibModalInstance.dismiss();
        }
      }

    }
  }

}
angular.module('eCareVault.common.popUp')
  .controller('FieldMetadataPopupController', FieldMetadataPopupController);
